import { matchYoutubeUrl } from '@/utils';
import { Button, Input, message, Space } from 'antd';
import { FC, useState } from 'react';

type Props = {
  onSubmit: (value) => void;
};

const YoutubeUrl: FC<Props> = (props: Props) => {
  const { onSubmit } = props;
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const onChange = ({ target: { value: targetValue } }) => {
    setValue(targetValue);
  };

  const handleSubmit = (url) => {
    if (!url) return;

    setLoading(true);
    if (!matchYoutubeUrl(url)) {
      setLoading(false);
      message.error('Url is not Youtube Url. Please check again.');
      return;
    }

    if (onSubmit) onSubmit(url);

    setLoading(false);
    setValue(null);
  };

  return (
    <Space.Compact style={{ width: '50%' }}>
      <Input placeholder="Youtube Url" value={value || ''} onChange={onChange} disabled={loading} />
      <Button type="primary" loading={loading} onClick={() => handleSubmit(value)}>
        Add
      </Button>
    </Space.Compact>
  );
};

export default YoutubeUrl;
